import enHK from './en-HK'
import zhHK from './zh-HK'

const resources = {
  'en-HK': {
    translation: enHK
  },
  'zh-HK': {
    translation: zhHK
  }
}

export default resources
